<template>
	<div class="date">
		<div class="date-box">
			<div class="title">
				<a @click="goWeb">进入官网</a>
				<span>{{year}}年{{month}}月{{date}}日</span>
				<a @click="showAlert=true">活动说明</a>
			</div>
			<div class="date-body">
				<div class="header">
					<span style="color:#bd8e5b">一</span>
					<span style="color:#bd8e5b">二</span>
					<span style="color:#bd8e5b">三</span>
					<span style="color:#bd8e5b">四</span>
					<span style="color:#bd8e5b">五</span>
					<span style="color:#686e3f">六</span>
					<span style="color:#686e3f">日</span>
				</div>

				<div class="body">
					<span v-for="(item,index) in dateList" :key="index" :class="backgroundFilter(item)">
						{{item.d}}<br />
						<div style="font-size:10px">{{!(item.isStart||item.isEnd)?item.lunar:'.'}}</div>
						<div v-show="item.isFinished" class="finished"><img src="../../assets/img/home/finished.png" />
						</div>
					</span>
				</div>
				<div class="sign-box">
					<img class="sign decorate" src="../../assets/img/home/decorate-left.png" />
					<img class="sign sign-btn" @click="$emit('sign')" src="../../assets/img/home/sign.png" />
					<img class="sign decorate" src="../../assets/img/home/decorate-right.png" />
				</div>
				<div style="text-align: center;color: #ac7a4a;">
					每名用户每日成功签到一次，可获得1次抽奖机会
				</div>
			</div>
		</div>
		<alert v-if="showAlert" @close="showAlert=false"></alert>
	</div>
</template>

<script>
	import alert from '@/components/home/alert.vue'
	import calendar, {
		defaultLunar,
		defaultGregorian
	} from '@/assets/js/calendar.js'
	export default {
		name: "date",
		props: ['signDate'],
		components: {
			alert
		},
		data() {
			return {
				showAlert: false,
				dateList: [],
				activityDateList: [
					[2022, 1, 25],
					[2022, 1, 26],
					[2022, 1, 27],
					[2022, 1, 28],
					[2022, 1, 29],
					[2022, 1, 30],
					[2022, 1, 31],
					[2022, 2, 1],
					[2022, 2, 2],
					[2022, 2, 3],
					[2022, 2, 4],
					[2022, 2, 5],
					[2022, 2, 6],
					[2022, 2, 7],
					[2022, 2, 8],
					[2022, 2, 9],
					[2022, 2, 10],
				],
				startDate: [2022, 2, 9],
				endDate: [2022, 2, 10],
				finishedList: [
					// [2022, 1, 2],
					// [2022, 1, 3],
					// [2022, 1, 4],
					// [2022, 1, 5],
					// [2022, 1, 6],
				],
				month: null,
				year: null,
				date: null,
				festival: {
					lunar: defaultLunar,
					gregorian: defaultGregorian
				},
			};
		},
		created() {
			this.init()
		},
		computed: {
			signDateList() {
				return this.signDate
			}
		},
		watch: {
			signDateList() {
				this.finishedList = []
				this.signDateList.forEach(item => {
					if (item.signFlag) {
						let date = new Date(item.signDate)
						this.finishedList.push([
							date.getFullYear(),
							date.getMonth() + 1,
							date.getDate()
						])
					}
				})

			},
			finishedList() {
				this.init()
			}
		},
		methods: {
			init() {
				this.dateList = []
				let now = Date.now()
				let nowMonth = new Date(now).getMonth() + 1
				let nowYear = new Date(now).getFullYear()
				let nowDate = new Date(now).getDate()
				this.month = nowMonth
				this.year = nowYear
				this.date = nowDate
				let index = new Date(nowYear, nowMonth - 1)
				let week = index.getDay()
				for (let i = 0; i < week; i++) {
					let t = new Date(index.getTime() - i * 24 * 60 * 60 * 1000)
					let tYeart = t.getFullYear()
					let tMonth = t.getMonth() + 1
					let tDate = t.getDate()
					this.dateList.unshift({
						y: tYeart,
						M: tMonth,
						d: tDate,
						isToday: tDate == nowDate && tMonth == nowMonth,
						isDefault: this.activityDateList.find(item => {
							if (tYeart == item[0] && tMonth == item[1] && tDate == item[2]) {
								if (tDate == nowDate && tMonth == nowMonth) {
									return false
								}
								return true
							}
						}),
						isStart: tDate == this.startDate[2] && tMonth == this.startDate[1],
						isEnd: tDate == this.endDate[2] && tMonth == this.endDate[1],
						isFinished: this.finishedList.find(item => {
							if (tYeart == item[0] && tMonth == item[1] && tDate == item[2]) {
								return true
							}
						}),
						lunar: this.getLunarInfo(tYeart, tMonth, tDate).lunar
					})
				}
				let max = nowMonth == 2 ? 35 : 42
				let length = index.getDay() < 4 ? (max - index.getDay()) : (max + 7 - index.getDay())
				for (let i = 0; i < length; i++) {
					let t = new Date(index.getTime() + (i + 1) * 24 * 60 * 60 * 1000)
					let tYeart = t.getFullYear()
					let tMonth = t.getMonth() + 1
					let tDate = t.getDate()
					this.dateList.push({
						y: tYeart,
						M: tMonth,
						d: tDate,
						isToday: tDate == nowDate && tMonth == nowMonth,
						isDefault: this.activityDateList.find(item => {
							if (tDate == nowDate && tMonth == nowMonth) {
								return false
							}
							if (tYeart == item[0] && tMonth == item[1] && tDate == item[2]) {
								return true
							}
						}),
						isStart: tDate == this.startDate[2] && tMonth == this.startDate[1],
						isEnd: tDate == this.endDate[2] && tMonth == this.endDate[1],
						isFinished: this.finishedList.find(item => {
							if (tYeart == item[0] && tMonth == item[1] && tDate == item[2]) {
								return true
							}
						}),
						lunar: this.getLunarInfo(tYeart, tMonth, tDate).lunar
					})
				}
			},
			backgroundFilter(item) {
				let result = ''
				if (item.isDefault) {
					result = result + ' default'
				}
				if (item.isToday) {
					result = result + ' today'
				}
				if (item.isStart) {
					result = result + ' start'
				}
				if (item.isEnd) {
					result = result + ' end'
				}
				return result
			},
			getLunarInfo(y, m, d) {
				const lunarInfo = calendar.solar2lunar(y, m, d);
				const {
					Term,
					lMonth,
					lDay,
					lYear
				} = lunarInfo || {};
				let yearEve = '';
				if (lMonth === 12 && lDay === calendar.monthDays(lYear, 12)) {
					yearEve = '除夕';
				}
				let lunarValue = lunarInfo.IDayCn;
				let isLunarFestival = false;
				let isGregorianFestival = false;
				if (this.festival.lunar[`${lunarInfo.lMonth}-${lunarInfo.lDay}`]) {
					lunarValue = this.festival.lunar[`${lunarInfo.lMonth}-${lunarInfo.lDay}`];
					isLunarFestival = true;
				} else if (this.festival.gregorian[`${m}-${d}`]) {
					lunarValue = this.festival.gregorian[`${m}-${d}`];
					isGregorianFestival = true;
				}
				const lunarInfoObj = {
					date: `${y}-${m}-${d}`,
					lunar: yearEve || Term || lunarValue,
					isLunarFestival,
					isGregorianFestival,
					isTerm: !!yearEve || lunarInfo.isTerm
				};
				return lunarInfoObj;
			},
			goWeb() {
				window.location.href = 'https://menpai.yofijoy.com/menpai/mb/index.html?type=99'
			}
		},
	};
</script>
<style scoped>
	.date {
		padding: 10px 6px;

	}

	.date-box {
		background: #e4c677;
		border-radius: 6px;
		overflow: hidden;
		box-shadow: 0 2px 12px 0 rgb(0, 0, 0, 0.3);
	}

	.title {
		display: flex;
		justify-content: space-around;
		width: 100%;
		background-color: #fff7d6;
		padding: 6px 0;
	}

	.title a {
		color: #b0954e;
		font-size: 14px;
	}

	.title span {
		color: #686e3f;
		font-size: 14px;
	}

	.date-body {
		padding: 6px;
	}

	.header,
	.body {
		width: 100%;
		background-color: #f6e9b2;
		border-radius: 6px;
	}

	.body {
		margin-top: 6px;
		padding: 6px 0;
	}

	.header span,
	.body span {
		text-align: center;
		display: inline-block;
		width: 14.27%;
		padding: 4px 0;
		font-weight: 600;
		font-size: 14px;
	}

	.body span {
		color: #ac7a4a;
		margin: 2px 0;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: contain;
		position: relative;
		text-align: center;
	}

	.today {
		background-image: url(../../assets/img/home/today.png);
	}

	.finished {
		position: absolute;
		display: block;
		margin: 0 auto;
		float: left;
		width: 100%;
	}

	.finished img {
		position: relative;
		top: -30px;
		width: 70%;
		max-width: 40px;
	}

	.default {
		background-image: url(../../assets/img/home/default.png);
	}

	.start {
		background-image: url(../../assets/img/home/start.png);
	}

	.end {
		background-image: url(../../assets/img/home/end.png);
	}

	.sign-box {

		display: flex;
		justify-content: space-around;
		width: 100%;
		padding: 6px 0;
	}

	.sign {
		width: 60px;
		display: block;
		margin: 0 auto;
		margin-top: 6px;
		margin: 0;
	}

	.sign-btn {
		height: 60px;
	}

	.decorate {
		width: 30%;
		height: 16px;
		margin-top: 20px;
	}
</style>
